import {
  SET_CHANNEL_LIST,
  SET_CHANNEL_LIST_PAGE_SIZE,
  SET_CHANNEL_PAGE_NUM,
  SET_CHANNEL_LIST_PAGE_TOTAL,
  SET_CHANNEL_LIST_QUERY,
  SET_CHANNEL_LIST_SEARCHING,

  SET_NATURAL_LIST,
  SET_NATURAL_PAGE_TOTAL,
  SET_NATURAL_QUERY,
  SET_NATURAL_PAGE_SIZE,
  SET_NATURAL_PAGE_NUM,
  SET_NATURAL_SEARCHING,
} from './mutation-types'
import api from '@/api'
import {objectTrim} from '@/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  name: '',
  // sourceType: 3,
})

const initNatualSourceQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  name: '',
  // sourceType: 2,
})

const state = {
  loading: false,
  initQuery: initQuery(),
  customSource: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  loadingNaturalSource: false,
  initNaturalSourceQuery: initNatualSourceQuery(),
  naturalSource: {
    list: [],
    listPageTotal: 0,
    query: initNatualSourceQuery(),
  },
}
const mutations = {
  [SET_CHANNEL_LIST](state, payload) {
    state.customSource.list = payload
  },
  [SET_CHANNEL_LIST_PAGE_TOTAL] (state, payload) {
    state.customSource.listPageTotal = payload
  },
  [SET_CHANNEL_LIST_QUERY] (state, payload) {
    state.customSource.query = {
      ...state.customSource.query,
      ...payload,
    }
  },
  [SET_CHANNEL_LIST_PAGE_SIZE](state, payload) {
    state.customSource.query.pageSize = payload
  },
  [SET_CHANNEL_PAGE_NUM](state, payload) {
    state.customSource.query.pageNum = payload
  },
  [SET_CHANNEL_LIST_SEARCHING] (state, payload) {
    state.loading = payload
  },
  // 自然来源管理
  [SET_NATURAL_LIST] (state, payload) {
    state.naturalSource.list = payload
  },
  [SET_NATURAL_PAGE_TOTAL] (state, payload) {
    state.naturalSource.listPageTotal = payload
  },
  [SET_NATURAL_QUERY] (state, payload) {
    state.naturalSource.query = {
      ...state.naturalSource.query,
      ...payload,
    }
  },
  [SET_NATURAL_PAGE_SIZE] (state, payload) {
    state.naturalSource.query.pageSize = payload
  },
  [SET_NATURAL_PAGE_NUM] (state, payload) {
    state.naturalSource.query.pageNum = payload
  },
  [SET_NATURAL_SEARCHING] (state, payload) {
    state.loadingNaturalSource = payload
  },
}
const actions = {
  async getList({ commit, state }, payload) {
    try {
      let params = {
        ...objectTrim(state.customSource.query),
      }
      commit(SET_CHANNEL_LIST_SEARCHING, true)
      let {data: {items, total}} = await api.monitorApi.querySource(params)
      commit(SET_CHANNEL_LIST_SEARCHING, false)
      commit(SET_CHANNEL_LIST, items)
      commit(SET_CHANNEL_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_CHANNEL_LIST, [])
      commit(SET_CHANNEL_LIST_PAGE_TOTAL, 0)
    }
  },
  async initPageList ({dispatch}) {
    await dispatch('setPageQuery', state.initQuery)
    await dispatch('getList')
  },
  setPageQuery ({commit}, payload) {
    commit(SET_CHANNEL_LIST_QUERY, payload)
  },
  async setListPageNum({ commit, dispatch }, payload) {
    commit(SET_CHANNEL_PAGE_NUM, payload)
    dispatch('getList')
  },
  async setListPageSize({ commit, dispatch }, payload) {
    commit(SET_CHANNEL_PAGE_NUM, 1)
    commit(SET_CHANNEL_LIST_PAGE_SIZE, payload)
    dispatch('getList')
  },
  // 自然来源管理
  async getNaturalList ({commit, state}) {
    try {
      let params = {
        ...objectTrim(state.naturalSource.query),
      }
      commit(SET_NATURAL_SEARCHING, true)
      let {data: {items, total}} = await api.monitorApi.queryNatureSource(params)
      commit(SET_NATURAL_SEARCHING, false)
      commit(SET_NATURAL_LIST, items)
      commit(SET_NATURAL_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_NATURAL_LIST, [])
      commit(SET_NATURAL_PAGE_TOTAL, 0)
    }
  },
  async initNaturalList ({dispatch}) {
    await dispatch('setNaturalPageQuery', state.initNaturalSourceQuery)
    await dispatch('getNaturalList')
  },
  setNaturalPageQuery ({commit, dispatch}, payload) {
    commit(SET_NATURAL_QUERY, payload)
  },
  setNaturalPageSize ({commit, dispatch}, payload) {
    commit(SET_NATURAL_PAGE_NUM, 1)
    commit(SET_NATURAL_PAGE_SIZE, payload)
    dispatch('getNaturalList')
  },
  setRNaturalPageNum ({commit, dispatch}, payload) {
    commit(SET_NATURAL_PAGE_NUM, payload)
    dispatch('getNaturalList')
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
